// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__sq00e","cursor":"styles_cursor__MZCly"};